import { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router-dom";
import { Can } from "@/shared/lib/casl";
import { useCoordinator } from "@shared/lib/hooks";
import { useNavigate, useAppRoutes } from "@shared/lib/react-router";
import "./object-tabs.scss";

export const ObjectTabs = () => {
  const navigate = useNavigate();
  const routes = useAppRoutes();
  const { projectId, objectId } = useCoordinator();
  const location = useLocation();

  const [activeKey, setActiveKey] = useState<string>();

  useEffect(() => {
    setActiveKey(location.pathname);
  }, [location.pathname]);

  const onTabChange = (key: string) => {
    navigate(key);
  };

  const baseTabs = [
    { key: routes.objects.object(projectId || "", objectId || ""), label: "Общая информация" },
    // {
    //   key: routes.objects.users(projectId, objectId),
    //   label: "Участники",
    //   disabled: true,
    // },
    { key: routes.objects.journals(projectId || "", objectId || ""), label: "Журналы" },
  ];

  const settingsTab = {
    key: routes.objects.settings(projectId || "", objectId || ""),
    label: "Настройки",
  };

  return (
    <>
      <Can I="edit" a="object">
        <Tabs
          activeKey={activeKey}
          items={[...baseTabs, settingsTab]}
          className="project-custom-tabs"
          onChange={onTabChange}
          tabBarStyle={{ overflow: "hidden" }}
          tabBarGutter={32}
          style={{ marginBottom: "32px" }}
        />
      </Can>
      <Can not I="edit" a="object">
        <Tabs
          activeKey={activeKey}
          items={baseTabs}
          className="project-custom-tabs"
          onChange={onTabChange}
          tabBarStyle={{ overflow: "hidden" }}
          tabBarGutter={32}
          style={{ marginBottom: "32px" }}
        />
      </Can>
    </>
  );
};
